module.exports = __webpack_public_path__ + "media/images/promo/onboarding-52950dd01aedf8281013a65cd3d71df66fddb5f13d055d0f707fdbd854d3189a.png";